const getOrigin = (urlString = '') => {
  const urlObject = new URL(urlString);
  return urlObject?.origin ?? '';
};

export default getOrigin;
